import { FileOutlined } from '@ant-design/icons';
import React from 'react';
import styles from './KlaviyoIntegrations.module.css';

export const Help = ({
  link,
  text = 'Help Docs',
}: {
  link: string;
  text?: string;
}) => (
  <div className={styles.help} onClick={() => window.open(link)}>
    <FileOutlined />
    <div className={styles.helpText}>{text}</div>
  </div>
);
